import { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { TenantCompanyService as Service } from './TenantCompanyService';
import { CityService } from './CityService';
import { TaxAuthorityService } from './TaxAuthorityService';
import { AppStorage } from '../../../../service/UserStorage';
import EventEmitter from '../../../../utils/EventEmitter';
import { TenantCompanyHistoryService } from './TenantCompanyHistoryService';

import { useForm } from '../../../../shared/hooks/Form';
import { useDataTable } from '../../../../shared/hooks/DataTable';
import { ToastService } from '../../../../AppToast';

export const Detail = () => {

  const [submitting, setSubmitting] = useState(false);
  const [displayLogs, setDisplayLogs] = useState(false);
  const [originData, setOriginData] = useState(null);
  const [hidenIdentityCode, setHidenIdentityCode] = useState(false);
  const [useIdentityCard, setUseIdentityCard] = useState(false);
  const [cities, setCities] = useState([]);
  const [taxAuthorities, setTaxAuthorities] = useState([]);

  useEffect(() => {
    CityService.getList({ maxResultCount: 1000 }).then(({ items }) => {
      setCities(items);
    });
    load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (originData && originData.cityCode && cities && cities.length) {
      cities.forEach(city => {
        if (city.code === originData.cityCode) {
          originData.city = city;
          setValue(originData);
        }
      });
    }
  }, [originData, cities]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (originData && originData.taxAuthoritiesId && taxAuthorities && taxAuthorities.length) {
      taxAuthorities.forEach(taxAuthority => {
        if (taxAuthority.id === originData.taxAuthoritiesId) {
          originData.taxAuthoritiesId = taxAuthority;
          setValue(originData);
          setOriginData(null);
        }
      });
    }
  }, [originData, taxAuthorities]); // eslint-disable-line react-hooks/exhaustive-deps

  const { render: renderForm, setValue, valid: formValid, getValue } = useForm({
    fields: [
      { field: 'taxCode', header: 'Mã số thuế', disabled: true, InputTextProps: { maxLength: 50 }, className: 'md:col-2' },
      { field: 'identityCode', header: 'Mã cơ quan thuế cấp', disabled: true, InputTextProps: { maxLength: 50 }, className: 'md:col-2' },
      { field: 'name', header: 'Tên đơn vị', required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-8' },

      { field: 'address', header: 'Địa chỉ', required: true, InputTextProps: { maxLength: 500 }, className: 'md:col-9' },
      { field: 'province', header: 'Tỉnh thành', required: true, InputTextProps: { maxLength: 50 }, className: 'md:col-3' },

      { field: 'bankAccount', header: 'Tài khoản', InputTextProps: { maxLength: 50 }, className: 'md:col-3' },
      { field: 'bankName', header: 'Tại ngân hàng', InputTextProps: { maxLength: 400 }, className: 'md:col-6' },
      { field: 'paymentCode', header: 'Mã tích hợp thanh toán', InputTextProps: { maxLength: 400 }, className: 'md:col-3' },

      { field: '', type: 'custom', className: 'md:col-12', body: <Divider className='m-0'><p className="text-base font-bold">THÔNG TIN NGƯỜI ĐẠI DIỆN PHÁP LUẬT</p></Divider> },

      { field: 'delegate', header: 'Người đại diện pháp luật', InputTextProps: { maxLength: 400 }, className: 'md:col-3' },
      { field: 'position', header: 'Chức vụ', InputTextProps: { maxLength: 50 }, className: 'md:col-3' },
      { field: 'legalRepPhone', header: 'Điện thoại người đại diện pháp luật', InputTextProps: { maxLength: 20 }, className: 'md:col-3' },
      { field: 'legalRepDob', header: 'Ngày sinh', type: 'Calendar', className: 'md:col-3' },

      { field: 'legalRepPassport', header: 'Hộ chiếu', InputTextProps: { maxLength: 20 }, className: 'md:col-3' },
      { field: 'identityCard', header: 'Căn cước công dân', InputTextProps: { maxLength: 12 }, required: useIdentityCard, className: 'md:col-2', },
      { field: 'useIdentityCard', header: 'Hộ kinh doanh sử dụng CCCD thay cho mã số thuế', type: 'Checkbox', required: false, className: 'md:col-4 flex align-items-end' },
      {
        field: 'legalRepGender', header: 'Giới tính', type: 'RadioButton', RadioButtonProps: {
          RadioButtons: [
            { className: 'md:col-6', value: 1, label: 'Nam' },
            { className: 'md:col-6', value: 0, label: 'Nữ' }
          ]
        },
        className: 'md:col-3',
      },
      { field: '', type: 'custom', className: 'md:col-12', body: <Divider className='m-0'><p className="text-base font-bold">THÔNG TIN NGƯỜI LIÊN HỆ</p></Divider> },

      { field: 'email', header: 'Email', type: 'email', InputTextProps: { maxLength: 50 }, className: 'md:col-6' },
      { field: 'tel', header: 'Điện thoại', InputTextProps: { maxLength: 15 }, className: 'md:col-6' },
      { field: 'webSite', header: 'WebSite', InputTextProps: { maxLength: 250 }, className: 'md:col-6' },
      { field: 'fax', header: 'Fax', InputTextProps: { maxLength: 15 }, className: 'md:col-6' },
      { field: '', type: 'custom', className: 'md:col-12', body: <Divider className='m-0'><p className="text-base font-bold">THÔNG TIN CƠ QUAN THUẾ, TRA CỨU HÓA ĐƠN</p></Divider> },

      { field: 'city', header: 'CQ thuế cấp tỉnh', type: 'Dropdown', DropdownProps: { options: cities, optionLabel: 'name', filter: true, resetFilterOnHide: true }, className: 'md:col-6' },
      { field: 'taxAuthoritiesId', header: 'CQ thuế quản lý', type: 'Dropdown', DropdownProps: { options: taxAuthorities, optionLabel: 'nameDisplay', filter: true, resetFilterOnHide: true }, className: 'md:col-6' },
      { field: 'agentInfo', header: 'Thông tin đại lý', disabled: true, required: false, InputTextProps: { maxLength: 500 }, className: 'md:col-12' },
    ]
  });

  const { city } = getValue();
  useEffect(() => {
    if (city && city.code) {
      TaxAuthorityService.getList({ cityCode: city.code, maxResultCount: 1000 }).then(({ items }) => {
        setTaxAuthorities(items);
      });
    }
  }, [city]);

  useEffect(() => {
    setUseIdentityCard(getValue().useIdentityCard);
  }, [getValue().useIdentityCard]);

  const load = () => {
    Service.get(AppStorage.get('tenant')).then((data) => {
      AppStorage.set('isHouseholdBusiness', data.isHouseholdBusiness === true ? 'true' : 'false');
      AppStorage.set('tenantInfo', JSON.stringify(data));
      EventEmitter.emit('changeTenantInfo', data);
      setOriginData(data);
      setValue(data);
    });
  }

  const handleSubmit = () => {
    if (!submitting && formValid()) {
      setSubmitting(true);

      const data = getValue();

      if (data.city) {
        data.cityCode = data.city.code;
        data.cityName = data.city.name;
        delete data.city;
      }
      if (data.taxAuthoritiesId) {
        data.taxAuthorityCode = data.taxAuthoritiesId.code;
        data.taxAuthorityName = data.taxAuthoritiesId.name;
        data.taxAuthoritiesId = data.taxAuthoritiesId.id;
        delete data.taxAuthority;
      }

      Service.update(AppStorage.get('tenant'), data).then(() => {
        ToastService.success();
        load();
      }).finally(() => {
        setSubmitting(false);
      });
    }
  }

  const { render: renderDataTable, reloadLazyData } = useDataTable({
    header: 'Lịch sử thay đổi',
    dataKey: 'id',
    columns: [
      { field: 'creatorName', header: 'Người sửa', width: 160 },
      { field: 'lastModificationTime', header: 'Ngày sửa', width: 180, dataType: 'date' },
      { field: 'name', header: 'Dữ liệu', minWidth: 200 }
    ],
    indexColumnWidth: 40,
    selectionMode: 'single',
    getList: (params) => {
      return TenantCompanyHistoryService.getList(params);
    }
  });

  const showLogsDialog = () => {
    reloadLazyData();
    setDisplayLogs(true);
  }

  return (
    <div className="surface-card p-5" style={{ width: '1300px', margin: '0 auto' }}>
      {renderForm()}

      <div className="flex justify-content-center">
        <Button label="Xem lịch sử thay đổi" icon="pi pi-clock" onClick={() => showLogsDialog()} className="p-button-text p-button-sm" />
        <Button label="Lưu" icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm" />
      </div>

      <Dialog header="Lịch sử thay đổi thông tin" visible={displayLogs} style={{ width: '80rem' }} position="top" onHide={() => setDisplayLogs(false)}>
        {renderDataTable()}

        <div className="flex justify-content-end mt-3">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplayLogs(false)} className="p-button-text p-button-sm" />
        </div>
      </Dialog>
    </div>
  )
}
